import type { WidgetType } from "constants/WidgetConstants";
import * as React from "react";
import type { WidgetProps, WidgetState } from "widgets/BaseWidget";
import TaroWidget from "widgetsTaro";
import { ValidationTypes } from "constants/WidgetValidation";
import type { Stylesheet } from "entities/AppTheming";
import { DefaultAutocompleteDefinitions } from "widgets/WidgetUtils";
import type { AutocompletionDefinitions } from "widgets/constants";
import TProgressWidget from "../component";
import { EventType } from "../../../constants/AppsmithActionConstants/ActionConstants";
import { DerivedPropertiesMap } from "../../../utils/WidgetFactory";
import { fontSizeOptions } from "../../../pages/Editor/ThemePropertyPane/controls/ThemeFormControl";
import { FontStyleTypes } from "constants/WidgetConstants";
import contentConfig from "./contentConfig";
import styleConfig from "./styleConfig";

class TProgress extends TaroWidget<TProgressWidgetProps, WidgetState> {
  constructor(props: TProgressWidgetProps) {
    super(props);
  }
  
  static getAutocompleteDefinitions(): AutocompletionDefinitions {
    return {
      value: "string",
      isVisible: DefaultAutocompleteDefinitions.isVisible,
    };
  }

  static getPropertyPaneContentConfig = contentConfig;
  static getPropertyPaneStyleConfig = styleConfig;

  static getMetaPropertiesMap(): Record<string, any> {
    return {
      isDirty: false,
      value: ''
    };
  }
  static getDerivedPropertiesMap(): DerivedPropertiesMap {
    return {
      getValue: `{{ this.value }}`
    };
  }
  static getDefaultPropertiesMap(): Record<string, string> {
    return {
      value: "defaultValue"
    };
  }

  updateWidgetProperty = (propertyValues: string) => {
    if (!this.props.isDirty) {
      this.props.updateWidgetMetaProperty("isDirty", true);
    }
    this.props.updateWidgetMetaProperty("value", propertyValues);
  }

  static getStylesheetConfig(): Stylesheet {
    return {
      boxShadow: "none",
      backgroundColor: "{{appsmith.theme.form.inputBorder.bgColor}}",
      borderColor: "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
      fontSize: "{{appsmith.theme.form.label.fontSize}}",
      color: "{{appsmith.theme.form.label.fontColor}}",
      fontStyle: "{{appsmith.theme.form.label.fontStyle}}",
      progresscolor: "{{appsmith.theme.colors.primaryColor}}",
    };
  }

  getPageView() {
    return (
      <TProgressWidget {...this.props} />
    );
  }

  static getWidgetType(): WidgetType {
    return "AT_PROGRESS_WIDGET";
  }
}

export interface TProgressWidgetProps extends WidgetProps {
  value: any[];
  label: string;
  onClick?: any;
  borderRadius: string;
  boxShadow?: string;
}

export default TProgress;
